<!--
 * @Author: Lemon C
 * @Date: 2024-06-12 14:47:33
 * @LastEditTime: 2025-03-11 18:30:50
-->
<template>
    <div class="sup-login-dialog" v-if="dialog_visible" @click.self="bg_click">
        <transition name="login_box_fade">
            <div class="login-box" v-if="login_box_visible">
                <img class="img-login" src="@/assets/imgs/logo/logo_blue.png" />
                <div class="panel-title-box">
                    <div
                        @click="panel_switch_loginType('password')"
                        :class="`panel-name ${panel_login_type === 'password' ? 'panel-name-active' : ''}`">
                        密码登录
                    </div>
                    <div class="panel-split-line"></div>
                    <div
                        @click="panel_switch_loginType('message')"
                        :class="`panel-name ${panel_login_type === 'message' ? 'panel-name-active' : ''}`">
                        短信登录
                    </div>
                </div>
                <el-form :model="panel_login_form" class="panel-elform" ref="ref_login_form" :rules="rules" v-if="panel_login_type === 'password'">
                    <el-form-item prop="userNameOrPhone">
                        <el-input
                            @focus="elinput_listen_focus('userNameOrPhone')"
                            placeholder="请输入手机号/用户名"
                            prefix-icon="User"
                            v-model="panel_login_form.userNameOrPhone">
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="password">
                        <el-input
                            @focus="elinput_listen_focus('password')"
                            placeholder="请输入密码"
                            show-password
                            prefix-icon="Lock"
                            v-model="panel_login_form.password">
                        </el-input>
                    </el-form-item>
                    <el-form-item class="panel-elform-last-form">
                        <div class="panel-elform-submit-btn" @click="panel_login_click">登录</div>
                    </el-form-item>
                    <el-form-item>
                        <div class="panel-elform-bottom-box">
                            <div class="panel-elform-bottom-right-box">
                                <span @click="panel_forget_click">忘记密码?</span>
                                <div class="p-elform-b-r-line"></div>
                                <span @click="panel_resigter_click">注册</span>
                            </div>
                        </div>
                    </el-form-item>
                </el-form>
                <el-form :model="panel_login_form" class="panel-elform" ref="ref_login_form" :rules="rules" v-if="panel_login_type === 'message'">
                    <el-form-item prop="phone">
                        <el-input
                            @focus="elinput_listen_focus('phone')"
                            @input="(value) => elinput_listen_input('phone', value)"
                            maxlength="11"
                            placeholder="请输入手机号码"
                            prefix-icon="Iphone"
                            v-model="panel_login_form.phone">
                        </el-input>
                    </el-form-item>
                    <div class="panel-elform-flex">
                        <el-form-item prop="validateNo">
                            <el-input
                                @focus="elinput_listen_focus('validateNo')"
                                @input="(value) => elinput_listen_input('validateNo', value)"
                                maxlength="6"
                                placeholder="请输入验证码"
                                prefix-icon="Key"
                                v-model="panel_login_form.validateNo">
                            </el-input>
                            <el-button
                                class="panel-elform-validatenum-btn"
                                :disabled="panel_login_form.btnDisable"
                                @click="panel_send_validateNo('MessageLogin')"
                                >{{ panel_login_form.btnName }}</el-button
                            >
                        </el-form-item>
                    </div>
                    <el-form-item class="panel-elform-last-form">
                        <div class="panel-elform-submit-btn" @click="panel_login_click">登录</div>
                    </el-form-item>
                </el-form>
            </div>
        </transition>
    </div>
</template>

// MOD-- JavaScript
<script setup>
import { ref, onMounted, getCurrentInstance, nextTick } from 'vue';
import { passwordRules, phoneRules } from '@/utils/formValidateRules';
import { sendValidateNoService } from '@/service/interface';
import { useRouterStore } from '@/stores/router';
import { useUserStore } from '@/stores/user';
import { useStateStore } from '@/stores/state';

const router_store = useRouterStore();
const user_store = useUserStore();
const state_store = useStateStore();
const { proxy } = getCurrentInstance();

const timer = ref(null);
const ref_login_form = ref(null);
const dialog_visible = ref(false);
const login_box_visible = ref(false);
const panel_login_type = ref('password'); //登录类型 password: 账号密码登录  message: 验证码登录
const panel_login_form = ref({
    userNameOrPhone: '',
    phone: '',
    validateNo: '',
    password: '',
    rememberMe: false,
    btnName: '发送验证码',
    btnDisable: true,
}); //登录面板form数据

// 验证手机号码规则
const validPhoneNo = (rule, value, callback) => {
    let reg = /^[1][2-9][0-9]{9}$/;
    if (reg.test(value)) {
        panel_login_form.value.btnDisable = false;
        callback();
    } else {
        panel_login_form.value.btnDisable = true;
        let reg2 = /^[1][2-9][0-9]{1}$/;
        if (value.length > 2 && !reg2.test(value.substr(0, 3))) {
            return callback(new Error('请输入合法的手机号码'));
        }
    }
};
const rules = ref({
    phone: [
        { required: true, message: '请输入手机号码', trigger: 'blur' },
        { pattern: phoneRules.pattern, message: phoneRules.message, trigger: 'blur' },
        { validator: validPhoneNo, trigger: 'blur' },
    ],
    userNameOrPhone: [
        { required: true, message: '请输入用户名', trigger: 'blur' },
        {
            pattern: /^[A-Za-z0-9_\u4e00-\u9fa5]{2,20}$|^[1][2-9][0-9]{9}$/,
            message: '手机号码或2-20位字符,仅可含汉字,字母,数字,下划线',
            trigger: 'blur',
        },
    ],
    validateNo: [
        { required: true, message: '请输入验证码', trigger: 'blur' },
        { pattern: /^[0-9]{6}$/, message: '请输入正确的验证码', trigger: 'blur' },
    ],
    password: [
        { required: true, message: '请输入密码', trigger: 'blur' },
        { pattern: passwordRules.pattern, message: passwordRules.message, trigger: 'blur' },
    ],
}); //校验规则

onMounted(() => {});

// MARK Expose 隐藏
const show_dialog = () => {
    dialog_visible.value = true;
    nextTick(() => {
        login_box_visible.value = true;
    });
};

// MARK Expose 隐藏
const hide_dialog = () => {
    login_box_visible.value = false;
    setTimeout(() => {
        dialog_visible.value = false;
    }, 500);
};

// MARK Click 底部点击
const bg_click = () => {
    hide_dialog();
};

// MARK Click  登录类型选择
const panel_switch_loginType = (loginType) => {
    panel_login_type.value = loginType;
    ref_login_form.value.clearValidate();
    panel_login_form.value = {
        userNameOrPhone: '',
        phone: '',
        validateNo: '',
        password: '',
        rememberMe: false,
        btnName: '发送验证码',
        btnDisable: true,
    };
};

// MARK el-input listen 聚焦
const elinput_listen_focus = (formProps) => {
    ref_login_form.value.clearValidate([formProps]);
};
// MARK el-input listen 输入
const elinput_listen_input = (formProps, value) => {
    if (isNaN(value)) {
        panel_login_form.value[formProps] = value.replace(/\D/g, '');
    }
};

// MARK Click 忘记密码
const panel_forget_click = () => {
    router_store.windowOpenPlatform(1);
};

// MARK Click 注册

const panel_resigter_click = () => {
    router_store.windowOpenPlatform(2);
};

// MARK Click 登录
const panel_login_click = () => {
    let validateFailFlag = false;
    let dictionary = {
        password: ['userNameOrPhone', 'password'],
        message: ['phone', 'validateNo'],
    };
    ref_login_form.value.validateField(dictionary[panel_login_type.value], (error) => {
        if (error) {
            validateFailFlag = true;
        }
    });
    if (validateFailFlag) return;
    if (panel_login_type.value === 'password') {
        login_service_password();
    } else {
        login_service_phone();
    }
};

// MARK login  密码登录
const login_service_password = () => {
    let params = {
        userNameOrPhone: panel_login_form.value.userNameOrPhone,
        password: panel_login_form.value.password,
        rememberMe: panel_login_form.value.rememberMe,
    };
    proxy.$showLoading();
    user_store.service_login(params, (response, error) => {
        proxy.$hideLoading();
        if (!error) {
            proxy.$message.success('登录成功');
            hide_dialog();
        } else {
            let message = error.split('#$');
            proxy.$message.error(message[0]);
            // 如果密码不正确，则清空密码
            if (message && message.length) {
                panel_login_form.value.password = '';
            }
        }
    });
};

// MARK login  短信登录
const login_service_phone = () => {
    let params = {
        phone: panel_login_form.value.phone,
        validateNo: panel_login_form.value.validateNo,
        rememberMe: panel_login_form.value.rememberMe,
    };
    proxy.$showLoading();
    user_store.service_phone_login(params, (response, error) => {
        proxy.$hideLoading();
        if (!error) {
            proxy.$message.success('登录成功');
            hide_dialog();
        } else {
            let message = error.split('#$');
            proxy.$message.error(message[0]);
        }
    });
};

// MARK 面板操作  发送验证码
const panel_send_validateNo = (validateType) => {
    let validateFailFlag = false;
    ref_login_form.value.validateField('phone', (error) => {
        if (error) {
            validateFailFlag = true;
        }
    });
    if (validateFailFlag) return;
    let params = {
        phone: panel_login_form.value.phone,
        validateType: validateType,
    };
    let startTime = new Date().getTime();
    panel_login_form.value.btnDisable = true;
    panel_login_form.value.btnName = `60s后重试`;
    timer.value = setInterval(() => {
        let currentTime = new Date().getTime();
        let deltaTime = parseInt((currentTime - startTime) / 1000);
        if (deltaTime >= 60) {
            clearInterval(timer.value);
            panel_login_form.value.btnDisable = false;
            panel_login_form.value.btnName = '发送验证码';
        } else {
            panel_login_form.value.btnName = `${60 - deltaTime}s后重试`;
        }
    }, 1000);
    sendValidateNoService(params).then((res) => {
        if (res.isSuccess) {
            proxy.$message.success('验证码发送成功');
        } else {
            proxy.$message.error(res.errMsg);
            panel_login_form.value.phone = '';
            panel_login_form.value.validateNo = '';
            ref_login_form.value.resetFields();
        }
    });
};

defineExpose({
    show_dialog,
    hide_dialog,
});
</script>

// MOD-- CSS
<style lang="less" scoped>
.sup-login-dialog {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: var(--color-main-bg-transparent);
    z-index: var(--login-z-index);

    .login-box {
        position: absolute;
        top: calc(5px + var(--nav-height));
        right: 48px;
        width: 400px;
        height: 430px;
        // max-height: 450px;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 48px 50px;
        box-sizing: border-box;
        background: var(--color-main-login-bg-dark-transparent);
        backdrop-filter: var(--color-main-backdrop-filte);
        // background: var(--color-main-login-backdrop-filter-background);
        // background-color: var(--color-main-login-bg-dark-transparent);
        border-radius: 8px;
        transition: opacity 0.5s ease-in-out;
        z-index: var(--login-z-index);

        .img-login {
            position: relative;
            width: 240px;
            height: 50px;
            flex-shrink: 0;
        }

        .panel-title-box {
            position: relative;
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding: 38px 50px;
            align-items: center;
            font-size: 13px;
            cursor: pointer;

            .panel-name {
                width: 80px;
                font-size: 13px;
                color: var(--color-main-text-dark-bg-primary);
                opacity: 0.6;
                transition: var(--animation-opacity-style);
                display: flex;
                justify-content: center;
                align-items: center;

                &:hover {
                    opacity: 1;
                }
            }

            .panel-name-active {
                font-size: 14px;
                opacity: 1;
            }

            .panel-split-line {
                width: 0px;
                height: 16px;
                border: 1px solid var(--color-main-border-white);
                opacity: 0.5;
            }
        }

        .panel-elform {
            position: relative;
            width: 100%;

            .el-form {
                position: relative;
                width: 100%;
            }

            .el-form-item {
                position: relative;
                width: 100%;
                height: 30px;
                margin-bottom: 26px;
            }

            .el-form-item__content {
                position: relative;
                display: flex;
                align-items: center;
            }

            .panel-elform-last-form {
                margin-bottom: 40px;
                cursor: pointer;
            }

            .panel-elform-submit-btn {
                height: 100%;
                width: 100%;
                background: var(--color-main-brand);
                border-radius: 2px;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                font-weight: 400;
                font-size: 13px;
                color: var(--color-main-text-brand-bg-primary);
            }

            .panel-elform-flex {
                position: relative;
                display: flex;
                justify-content: space-between;

                .panel-elform-validatenum-btn {
                    position: relative;
                    margin-left: 10px;
                    height: 100%;
                }
            }

            .panel-elform-bottom-box {
                position: relative;
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: flex-end;

                .panel-elform-bottom-right-box {
                    position: relative;
                    display: flex;
                    align-items: center;
                    font-weight: 400;
                    font-size: 13px;
                    color: var(--color-main-text-dark-bg-primary);

                    span {
                        cursor: pointer;
                    }

                    .p-elform-b-r-line {
                        position: relative;
                        width: 1px;
                        height: 12px;
                        background: var(--color-main-light-bg-white);
                        margin: 0 10px;
                    }
                }
            }
        }

        :deep(.el-input) {
            height: 30px;
            --el-input-width: unset !important;
            flex: 1;
            font-size: 13px;

            .el-input__wrapper {
                .el-input__inner {
                    color: var(--color-main-text-primary);
                    border: none;
                    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
                    border-radius: 0px;
                    background-color: var(--color-main-bg-transparent) !important;
                    font-size: 13px;
                }
            }
        }

        :deep(.el-checkbox) {
            color: var(--color-main-text-dark-bg-primary);

            .el-checkbox__label {
                color: var(--color-main-text-dark-bg-primary) !important;
            }
        }

        :deep(.el-button) {
            border: none;
            color: var(--color-main-text-brand-bg-primary) !important;
            background: var(--color-main-brand);
            font-size: 13px;

            &:hover {
                color: var(--color-main-brand) !important;
                background: var(--color-main-light-bg-white);
            }
        }

        .el-button.is-disabled,
        .el-button.is-disabled:focus,
        .el-button.is-disabled:hover {
            color: var(--color-main-brand);
        }
    }

    .login_box_fade-enter-active,
    .login_box_fade-leave-active {
        transition: opacity 0.5s;
    }

    .login_box_fade-enter-from,
    .login_box_fade-leave-to {
        opacity: 0;
    }
}
</style>
